import { Component, OnInit } from '@angular/core';
import { HelperProvider } from '../providers/helper.provider';
import { Page } from '../model/page';
import { RestService } from '../providers/rest.service';
import { MasterListPage } from '../model/master-list-page';
import { Pair } from '../model/pair';
import { Master } from '../model/master';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-master-list',
  templateUrl: './master-list.component.html',
  styleUrls: ['./master-list.component.css']
})
export class MasterListComponent implements OnInit {
  source: MasterListPage = null;
  showSearchCurrentPage = 1;
  showSearchResultCount = 10;
  showSearchResultCountModel: number[] = [10, 20, 50, 100];
  masterAraLoading = false;
  masterAraText = '';
  filterEntities: Pair[] = [];

  ParaBirimi = Master.ParaBirimi;
  OdemeYontemi = Master.OdemeYontemi;
  TeslimYeri = Master.TeslimYeri;
  TeslimSekli = Master.TeslimSekli;
  Sehir = Master.Sehir;
  SarfYeri = Master.SarfYeri;
  FaturaTipi = Master.FaturaTipi;
  Lokasyon = Master.Lokasyon;
  UrunCinsi = Master.UrunCinsi;
  AracTipi = Master.AracTipi;
  iceriAktarSource: Master[];

  constructor(private helperProvider: HelperProvider,
    private restService: RestService,
    private router: Router,
    private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.Master);

    this.filterEntities.push(new Pair(Master.ParaBirimi, true));
    this.filterEntities.push(new Pair(Master.OdemeYontemi, true));
    this.filterEntities.push(new Pair(Master.TeslimYeri, true));
    this.filterEntities.push(new Pair(Master.TeslimSekli, true));
    this.filterEntities.push(new Pair(Master.Sehir, true));
    this.filterEntities.push(new Pair(Master.SarfYeri, true));
    this.filterEntities.push(new Pair(Master.FaturaTipi, true));
    this.filterEntities.push(new Pair(Master.Lokasyon, true));
    this.filterEntities.push(new Pair(Master.UrunCinsi, true));
    this.filterEntities.push(new Pair(Master.AracTipi, true));

    this.getEntitiesPage();
  }

  getEntitiesPage() {
    const types = this.filterEntities.filter(x => x.value).map(x => x.key);
    this.restService.getEntitiesPage(this.showSearchCurrentPage, this.showSearchResultCount, types).subscribe(res => {
      if (res != null) {
        this.source = res;
        // console.log(this.source);
      }
    });
  }

  showPreviousPageSearchResults() {
    this.showSearchCurrentPage--;
    this.getEntitiesPage();
  }

  showNextPageSearchResults() {
    this.showSearchCurrentPage++;
    this.getEntitiesPage();
  }

  masterAraInputChange() {
    this.getEntitiesPage();
  }

  filter(key) {
    for (const f of this.filterEntities) {
      if (f.key === key) {
        f.value = !f.value;
      }
    }
    this.getEntitiesPage();
  }

  new() {
    this.router.navigate(['master'], { queryParams: { id: '0' } });
  }

  sarfYeriAktar(preview: boolean) {
    this.iceriAktarSource = null;
    this.restService.sarfYeriAktar(preview).subscribe(res => {
      if (res) {
        if (preview) {
          this.iceriAktarSource = res;
          if (this.iceriAktarSource.length === 0) {
            alert('aktarılacak sonuç bulunamadı!');
          }
        } else {
          this.getEntitiesPage();
        }
      }
    });
  }

  lokasyonAktar() {
    this.restService.netsisLokasyonAktar().subscribe(res => {
      this.toastrService.success("Aktarım Tamamlandı!", "Başarılı!");
    });
  }

  edit(c: Master) {
    this.router.navigate(['master'], { queryParams: { id: c.id } });
  }

  delete(c: Master) {
    if (confirm(`${c.id} masteri silmek istediğinize emin misiniz?`)) {
      this.restService.masterSil(c.id).subscribe(res => {
        if (res) {
          this.getEntitiesPage();
        }
      });
    }
  }
}
